
import React from 'react'
import FormField from './FormField'

/**
 * SelectField component.
 */

export default function SelectField({ label, hint, children, ...props }) {
  const { name, disabled, required } = props
  return <FormField
    name={name}
    label={label}
    hint={hint}
    disabled={disabled}
    required={required}
  >
    <select className="Select" {...props}>
      {children}
    </select>
  </FormField>
}